/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReportButton_settings = {
    readonly dsa: {
        readonly enabled: boolean;
    };
    readonly " $refType": "ReportButton_settings";
};
export type ReportButton_settings$data = ReportButton_settings;
export type ReportButton_settings$key = {
    readonly " $data"?: ReportButton_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"ReportButton_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReportButton_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "DSAConfiguration",
            "kind": "LinkedField",
            "name": "dsa",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enabled",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '4697180f33f58d546cd493be72d57fe2';
export default node;
